<template>
  <div>
    <!--    <spinner />-->
    <v-form>
      <v-container class="py-0 px-8 login">
        <v-row>
          <v-col
            cols="12"
            class="page-padding mb-8 d-flex justify-center align-center"
          >
            <!--span class="page-title">Login</span-->
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
   
<script>
/* 로그인폼 컴포넌트 */
import { checkAccessToken } from '@/api/auth';
import { getLBSInfo } from '@/api/main';
import { mapMutations } from 'vuex';
import routerConstants from '@/const/routerConstants';

export default {
  computed: {},

  watch: {},

  methods: {
    ...mapMutations('SPINNER', ['ON_COMMON_SPINNER', 'OFF_COMMON_SPINNER']),
    /* Token 확인 */
    async accessTokenCheck(tokenParam) {
      // 파라미터 세팅
      const paramObj = {
        token: tokenParam,
      };

      try {
        const tokenCheckResponse = await checkAccessToken(paramObj);
        const resultCode = tokenCheckResponse.data.data.code;
        const resultMessage = tokenCheckResponse.data.data.message;
        const resultStatus = tokenCheckResponse.data.data.status;
        const tokenData = tokenCheckResponse.data.data.result;

        if (resultCode === '0') {
          this.$store.commit('setToken', tokenData);
          this.$store.commit('setUserData', tokenData);
          this.$store.commit('SET_SECOND_AUTHENTICATE', false);
          this.$store.commit('SET_SHOW_SECOND_AUTHENTICATE', false);
          this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
          this.$router.push(routerConstants.Main);
        } else if (resultCode === '2') {
          // IBGF로 이동
          const url = 'exit_webview';
          location.href = url;

        } else {
          this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
          //this.$router.push(routerConstants.Error);
          
          this.$router.push({
            name: routerConstants.Error,
            params: { message: resultMessage, status: resultStatus },
          });
          
        }
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
        this.$router.push(routerConstants.Error);
      }
    },
    async getLBSInfo() {
      const { data } = await getLBSInfo();
      // console.log(data.data.scanningTypes);
    },
  },

  created() {
    this.ON_COMMON_SPINNER(); // 공통 스피너 ON
    //ehr mob 에서 발급한 인증 Token을 ibgf받아서 발급확인후 넘겨준 Token
    const paramToken = this.$route.query.T;
    if (paramToken != undefined && paramToken != null && paramToken != '') {
      this.accessTokenCheck(paramToken);
    } else {
      this.$router.push(routerConstants.Error);
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  components: {},
};
</script>

<style></style>
